import React, { useEffect, useState, useRef } from "react";
import DocumentViewerStyle from "./DocumentViewer.module.scss";
import { Document, Page, pdfjs } from "react-pdf";
import "pdfjs-dist/web/pdf_viewer.css";
import "./DocumentViewer.scss";
import { useScreenType } from "globals/screenTypeHook.jsx";
import ReactDom from "react-dom";
import logger from "utils/logger";

const DocumentViewer = ({showDocument, fileData="", fileLink="", onClose}) => {
  const [file, setFile] = useState("");
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [fileType, setFileType] = useState(""); 
  const imgContainerRef = useRef(null);
  const imgRef = useRef(null);
  const pdfRef = useRef(null); 
  const frameRef = useRef(null);  
  const pdfContainerRef = useRef(null);
  const [isScrollable, setIsScrollable] = useState(false);
  const { width, screenType, isMobile, isDesktop, isTablet, isLargeDesktop } = useScreenType();
  const [scale, setScale] = useState(
   0.5
  );
//  isMobile ? 0.5 : isDesktop && 0.9
  const zoomIn = "/assets/img/documentViewer/plus.svg";
  const zoomOut = "/assets/img/documentViewer/minus.svg";
  const email = "/assets/img/documentViewer/emailIcon.svg";
  const printer = "/assets/img/documentViewer/printer.svg";
  const download = "/assets/img/documentViewer/download.svg";
  const leftArrow = "/assets/img/documentViewer/leftArrow.svg";
  const rightArrow = "/assets/img/documentViewer/rightArrow.svg";
  const noSupport = "/assets/img/documentViewer/no-image.svg";

  //center image and doc
  useEffect(() => {
    setTimeout(()=>{
      const container = fileType === "pdf" ? pdfContainerRef?.current : imgContainerRef?.current;
      const content = fileType === "pdf" ? pdfRef?.current : imgRef?.current;
      const frame = frameRef?.current;  
      if (container && content && frame) {
        container.scrollLeft = (content.offsetWidth - container.clientWidth) / 2;
        container.scrollTop  = (content.offsetHeight - frame.clientHeight) / 2;
      }
    },100)  
  }, [showDocument, width, imgContainerRef, frameRef, imgRef, pdfRef]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);

    const container = fileType === "pdf" ? pdfContainerRef?.current : imgContainerRef?.current;
    const content = fileType === "pdf" ? pdfRef?.current : imgRef?.current;
    const frame = frameRef?.current;  
    if (container && content && frame) {
      container.scrollLeft = (content.offsetWidth - container.clientWidth) / 2;
      container.scrollTop  = (content.offsetHeight - frame.clientHeight) / 2;
    }
  };

  function detectTypeFromLocation(path) {
    const ext = path.split("/").pop().split("\\").pop().split(".").pop().toLowerCase();

    if (["jpg","jpeg","png","gif","webp"].includes(ext)) return "image";
    if (ext === "pdf") return "pdf";

    return null; // unknown
  }

  useEffect(() => { 
    logger.log("url: ", fileData, fileData.match(/^data:application\/pdf;base64,/));
  if(fileLink !== ""){
      logger.log("detectTypeFromLocation: ",detectTypeFromLocation(fileLink));
      setFileType(detectTypeFromLocation(fileLink));
      setFile(fileLink);
    }
  if(fileData !== ""){  
      let blob; 
      if(fileData.match(/^data:application\/pdf;base64,/)){  
        setFile(fileData);
        setFileType("pdf"); 
      } else { 
        setFile(fileData);
        setFileType("img"); 
      }  
    }
  }, [fileData, fileLink, showDocument]);

  const checkScrollable = () => {
    const el = pdfContainerRef.current;
    if (!el) return;
    // check if content overflows horizontally
    setIsScrollable(el.scrollWidth > el.clientWidth);

    if (screenType === "mobile" || screenType === "small-mobile" || screenType === "medium-mobile") {
      setScale(.5);
    } else if (screenType === "medium-mobile" || screenType === "tablet") {
      setScale(.7);
    } else {
      setScale(.9);
    }
  };

  useEffect(() => { 
    setTimeout(()=>{
      checkScrollable();
    }, 1000)
     
     
    // re-check on resize
    window.addEventListener("resize", checkScrollable);
    return () => window.removeEventListener("resize", checkScrollable);
  }, [showDocument, screenType]);


  return ReactDom.createPortal(
    <>
      {showDocument ? <div  className={DocumentViewerStyle.outerContainer} >
        <div className={DocumentViewerStyle.innerContainer} >
          {/* Close Button */}
          <button 
            onClick={onClose} 
            className={DocumentViewerStyle.closeButton}
          >
            ✕
          </button>
          {/* Document Frame */} 
          <div ref={frameRef} className={DocumentViewerStyle.frameStyle} >
              <div className={DocumentViewerStyle.headerControls}>
                <div className={DocumentViewerStyle.innerControlsContainer}>
                  <button className={DocumentViewerStyle.zoomInBtn} onClick={() => setScale(s =>  s + 0.2 )}><img src={zoomIn}/></button>
                  <button className={DocumentViewerStyle.zoomOutBtn} onClick={() => setScale(s => Math.max(s - 0.2, 0.5))}><img src={zoomOut}/></button>
                </div> 
              </div> 
    
              { fileType !== "pdf" && fileType !== null ?
                <div ref={imgContainerRef} className={DocumentViewerStyle.imgContainer}>
                  <img ref={imgRef} src={file} style={{scale: `${scale}`}}/>
                </div>
              : fileType === "pdf" && fileType !== null ? <>
                <div className={DocumentViewerStyle.footerControls}>
                  <div style={{ display:"flex" }}>
                    <button className={DocumentViewerStyle.previousBtn} onClick={() => setPageNumber(p => Math.max(p - 1, 1))}><img src={leftArrow} /></button>
                    <span style={{ whiteSpace:"no-wrap", padding:"0 10px"}}>
                      Page {pageNumber} of {numPages}
                    </span>
                    <button className={DocumentViewerStyle.nextBtn} onClick={() => setPageNumber(p => Math.min(p + 1, numPages))}><img src={rightArrow} /></button>
                  </div>
                </div>
                <div ref={pdfContainerRef} className={DocumentViewerStyle.documentContainer} style={{ justifyContent: isScrollable ? "flex-start" : "center"}}>
                  <Document   
                    file={file}
                    onLoadSuccess={onDocumentLoadSuccess}
                  >
                    <Page inputRef={pdfRef} pageNumber={pageNumber} scale={scale} className={DocumentViewerStyle.docViewerPage}/>
                  </Document>
                </div>
              </> : 
                <div className={DocumentViewerStyle.unsupportedFormatSection}>
                  <img src={noSupport} width={15} height={15}/>
                  <p>Format Not Supported</p>
                </div> }
          </div>
        </div>
      </div> : <></>}
    </>, document.body
  );
};

function base64ToBlob(base64, mime) {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mime });
}

export default DocumentViewer;
